import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { PatientDetails, UUID } from "@/core/types";

import { getPatientDetails } from "../queryFunctions/getPatientDetails";
import { patientKeys } from "../keyFactory";

type UsePatientDetailsProps<TData = PatientDetails> = {
  patientId: UUID;
  select?: (data: PatientDetails) => TData;
};

export function usePatientDetails<TData = PatientDetails>({
  patientId,
  select,
}: UsePatientDetailsProps<TData>) {
  return useQuery({ ...optionFactory(patientId), select });
}

type PatientDetailsQueryOptions = UseQueryOptions<
  PatientDetails,
  unknown,
  PatientDetails,
  ReturnType<typeof patientKeys.details>
>;

// callers can use queryClient.prefetchQuery(optionFactory(patientId))
// or queryClient.getQueryData(optionFactory(id).queryKey) with correct typing
// without duplicating the key or queryFn
function optionFactory(patientId: UUID) {
  return {
    queryFn: () => getPatientDetails(patientId),
    queryKey: patientKeys.details(patientId),
  } satisfies PatientDetailsQueryOptions;
}
